import { createSelector } from 'reselect';

import { initialState, State } from './reducers';
import { key } from './constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const selectState = (state: any): State => state.get(key) || initialState;

export const selectDateFrom = createSelector(selectState, (state) => state.dateFrom);
export const selectDateTo = createSelector(selectState, (state) => state.dateTo);
